
import Vue from 'vue';
import moment from 'moment';
import Tabs from '@/components/NavTabs/index.vue';
import Tab from '@/components/NavTab/index.vue';
import Button from '@/components/Button/index.vue';
import PaymentInstallments from './PaymentInstallments/index.vue';
import PaymentPix from './PaymentPix/index.vue';
import { Wrapper } from './styles';

declare module 'vue/types/vue' {
  interface Vue {
    formatNumber: Function;
  }
}

moment.locale('pt-br');

export default Vue.extend({
  components: {
    Wrapper,
    PaymentInstallments,
    PaymentPix,
    Tabs,
    Tab,
    Button,
  },
  inject: ['getStepDate'],
  data() {
    return {
      isDisabled: false,
      boolShow: false,
      boolShowPix: false,
    };
  },
  methods: {
    formatNumber(value: number) {
      return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    },
    returnHome() {
      this.$router.push('/produtor/territory');
    },
    moreDetails() {
      this.$data.boolShow = true;
    },
    moreDetailsPix() {
      this.$data.boolShowPix = true;
    },
  },
  provide() {
    return {
      formatNumber: this.formatNumber,
    };
  },
  created() {
    const verify = sessionStorage.getItem('skip');
    if (verify === 'true') {
      console.log('Sucess');
      this.getStepDate.currentStep += 1;
    }
  },
});
